export const translation = {
  en: {
    PLANNING: 'PLANNING',
    INPUTS: 'Enter Your Inputs',
    TARGET_SAVING: {
      TITLE: 'Target Saving',
      SUBTITLE:
        'Determine how much you should save each month to reach your financial goal. This can be any goal you have for the medium to long term. Below are two examples.',
      TARGET_AMOUNT: 'Target amount in today’s dollars:',
      INFLATION_RATE: 'Expected annual inflation rate:',
      INFLATION_RATE_POPUP:
        "Central Bank's target is 2% for a general basket of goods and services. Adjust it for your specific saving goal or leave it at 2%.",
      CURRENT_AMOUNT: 'How much you have now:',
      INPUT_VALUE: 'Input value',
      REQUIRED_FIELD: 'This field is required',
      REQUIRED_PORTFOLIO: 'Please select a portfolio',
      REQUIRED_ACCOUNT: 'Please select an account',
      ANALYZE_ERROR:
        'This account cannot be analyzed. Please select another account or portfolio.',
      SHORT_HISTORY_PORTFOLIO_1: 'This portfolio has a start date of',
      SHORT_HISTORY_PORTFOLIO_2:
        '(longest common history of the holdings). You can continue with this portfolio, but the simulated outcomes may be misleading. We recommend using a portfolio with a longer history (10 years+). You can use the ETF Portfolio Builder in the "Portfolios" segment to save a model portfolio.',
      SHORT_HISTORY_ACCOUNT_1:
        'The portfolio in this account has a start date of',
      SHORT_HISTORY_ACCOUNT_2:
        '(longest common history of the holdings). You can continue with this account, but the simulated outcomes may be misleading. We recommend that you use/enter a different account with at least 10 year of history. (Analyze an account to see the longest common history.)',
      SELECT_VALUE_ACCOUNTS: 'Select from accounts',
      SELECT_VALUE_PORTFOLIOS: 'Select a portfolio',
      YEARS_TO_DATE: 'Years to target date:',
      SELECT_PORTFOLIO: 'Select Portfolio',
      SELECT_PORTFOLIO_SUBTITLE:
        'Select the portfolio you’ll invest in to reach your goal. Choose a saved portfolio or an existing investment account.',
      RESULTS_TITLE: 'How Much to Save Per Month',
      RESULTS_SUBTITLE:
        'Add this amount to your portfolio. Since the portfolio has uncertain outcomes, how much you need to save is associated with a probability. The probability represents the likelihood of reaching your goal by the target date. The results are generated based on 10,000 simulations.',
      LIKELIHOOD_OF_SUCCESS: 'Likelihood of Success',
      LIKELIHOOD_POPUP:
        'The estimated probability of reaching your target amount by your target date if you save the monthly amount shown.',
      LIKELIHOOD_TEXT_1:
        'Without additional savings, the probability of reaching your target wealth is',
      LIKELIHOOD_TEXT_2:
        'To improve the probability of reaching your goal, please select a monthly savings target below:',
      REQUIRED_MONTHLY_SAVINGS: 'Required Monthly Savings',
      MONTHLY_ABBREVIATION: '/mo',
      SHOW_GRAPH: 'Show graph',
      SHOW_DETAILS: 'Show Details',
      HIDE_DETAILS: 'Hide Details',
      SIMULATED_SAVING_OUTCOMES: 'SIMULATED SAVING OUTCOMES',
      GRAPH_SUBTITLE:
        'of the Final Outcomes at Target Date Lie Above the "Meets Goal" Value (Red Dot)',
      GRAPH_SUBSUBTITLE: 'The future value of your goal is $',
      GRAPH_SUBSUBTITLE_POPUP: 'Assuming an average annual inflation rate of ',
      GRAPH_LEGEND_LOW: 'Lowest to 5th Percentile',
      GRAPH_LEGEND_MIDDLE: '5th Percentile to Meets Goal',
      GRAPH_LEGEND_HIGH: 'Meets Goal to 95th Percentile',
      GRAPH_X_AXIS: 'Months to target date',
      LEARN_MORE: 'Learn More',
      SHOW_LESS: 'Show Less',
      RESULTS_SAVING_PREFIX: 'Saving',
      RESULTS_MONTH_SUFFIX: '/ month for',
      RESULTS_YEARS_SUFFIX: 'years',
      FUTURE_VALUE_LABEL: 'Future Value of Goal',
      TOTAL_CONTRIBUTIONS_LABEL: 'Total Contributions',
      TOTAL_RETURNS_LABEL: 'Total Returns',
      TOTAL_RETURNS_SUB: 'of simulated total investment returns lie above',
      STARTING: 'starting',
      ADDITIONAL: 'additional',
      INFLATION_SUFFIX: '% inflation',
      IN_YEARS_PREFIX: 'In',
      YEARS_AT: 'years at',
      SIMULATED_OUTCOMES_TITLE: 'Simulated Saving Outcomes',
      CHART_SUBTITLE_1:
        'of the final outcomes at target date lie above the future value of your goal',
      EDUCATION: {
        TITLE: "Saving for Your Child's Education (RESP)",
        SUBTITLE: 'Start planning now. They grow up fast.',
        TABLE_TITLE: 'Average Education Cost in Canada (2025)',
        TABLE_SUBTITLE: 'Post-Secondary / 4-Year Total',
        TUITION: 'Tuition:',
        ROOM_AND_BOARD: 'Room & Board:',
        TOTAL: 'Total:',
        CONTRIBUTION_TITLE: 'RESP Maximum Lifetime Contribution:',
        CONTRIBUTION_SUBTITLE: '$50,000 per eligible beneficiary',
        GRANT_TITLE: 'CESG (Canada Education Savings Grant):',
        GRANT_TEXT:
          'The grant amount is 20% of your annual contributions up to $500 per year and a lifetime maximum of $7,200 per beneficiary. For more information, visit',
        HERE: 'here',
        QESI_TITLE: 'Quebec Education Savings Incentive (QESI):',
        QESI_TEXT:
          'Quebec residents can receive a refundable provincial tax credit of 10% on annual RESP contributions, up to $250 per year per beneficiary, with a lifetime maximum of $3,600. The QESI is paid directly into your RESP.',
      },
      RETIREMENT: {
        TITLE: 'Saving for Retirement (RRSP)',
        SUBTITLE: 'Build wealth for your golden years.',
        TARGET_TITLE: 'Retirement Planning Target',
        TARGET_SUBTITLE: '$500K to $1M+',
        TARGET_TEXT:
          'How much you need for retirement varies based on desired lifestyle and goals. Try different scenarios below, find what works for you, and start your monthly contributions.',
        RRSP_TITLE: 'RRSP Maximum 2026:',
        RRSP_SUBTITLE:
          'The contribution limit is 18% of your earned income, up to the annual maximum of $33,810. This limit could be lower if you have an employer pension plan, or higher if you have unused room from previous years. Check your Notice of Assessment from the CRA.',
      },
    },
  },
  fr: {
    PLANNING: 'PLANIFICATION',
    INPUTS: 'Entrez vos données',
    TARGET_SAVING: {
      TITLE: 'Objectif d’épargne',
      SUBTITLE:
        'Déterminez combien vous devriez épargner chaque mois pour atteindre votre objectif financier. Il peut s’agir de n’importe quel objectif à moyen ou long terme. Voici deux exemples ci-dessous.',
      TARGET_AMOUNT: 'Montant cible en dollars d’aujourd’hui :',
      INFLATION_RATE: 'Taux d’inflation annuel prévu :',
      INFLATION_RATE_POPUP:
        'La cible de la Banque du Canada est de 2 % pour un panier général de biens et services. Ajustez selon votre objectif d’épargne ou laissez 2 % par défaut.',
      CURRENT_AMOUNT: 'Montant que vous avez actuellement :',
      INPUT_VALUE: 'Valeur à entrer',
      REQUIRED_FIELD: 'Ce champ est requis',
      REQUIRED_PORTFOLIO: 'Veuillez sélectionner un portefeuille',
      REQUIRED_ACCOUNT: 'Veuillez sélectionner un compte',
      ANALYZE_ERROR:
        'Ce compte ne peut pas être analysé. Veuillez choisir un autre compte ou portefeuille.',
      SHORT_HISTORY_PORTFOLIO_1: 'Ce portefeuille a une date de début au',
      SHORT_HISTORY_PORTFOLIO_2:
        '(l’historique commun le plus long des titres). Vous pouvez continuer avec ce portefeuille, mais les résultats simulés pourraient être trompeurs. Nous recommandons d’utiliser un portefeuille avec un historique plus long (10 ans ou plus). Vous pouvez créer un portefeuille modèle dans la section « Portefeuilles » avec le Constructeur de portefeuilles FNB.',
      SHORT_HISTORY_ACCOUNT_1:
        'Le portefeuille de ce compte a une date de début au',
      SHORT_HISTORY_ACCOUNT_2:
        '(l’historique commun le plus long des titres). Vous pouvez continuer avec ce compte, mais les résultats simulés pourraient être trompeurs. Nous vous recommandons d’utiliser un compte différent avec au moins 10 ans d’historique (analyser un compte pour voir la durée commune la plus longue).',
      SELECT_VALUE_ACCOUNTS: 'Sélectionnez un compte',
      SELECT_VALUE_PORTFOLIOS: 'Sélectionnez un portefeuille',
      YEARS_TO_DATE: 'Années jusqu’à la date cible :',
      SELECT_PORTFOLIO: 'Sélectionner un portefeuille',
      SELECT_PORTFOLIO_SUBTITLE:
        'Choisissez le portefeuille dans lequel vous investirez pour atteindre votre objectif. Sélectionnez un portefeuille enregistré ou un compte d’investissement existant.',
      RESULTS_TITLE: 'Montant à épargner par mois',
      RESULTS_SUBTITLE:
        'Ajoutez ce montant à votre portefeuille. Comme les rendements sont incertains, le montant requis est associé à une probabilité. Celle-ci représente la chance d’atteindre votre objectif à la date prévue. Les résultats sont basés sur 10 000 simulations.',
      LIKELIHOOD_OF_SUCCESS: 'Probabilité de réussite',
      LIKELIHOOD_POPUP:
        'Estimation de la probabilité d’atteindre votre montant cible à la date prévue si vous épargnez le montant mensuel indiqué.',
      LIKELIHOOD_TEXT_1:
        'Sans épargne supplémentaire, la probabilité d’atteindre votre objectif est de',
      LIKELIHOOD_TEXT_2:
        'Pour améliorer vos chances d’atteindre votre objectif, choisissez ci-dessous un montant d’épargne mensuelle :',
      REQUIRED_MONTHLY_SAVINGS: 'Épargne mensuelle requise',
      MONTHLY_ABBREVIATION: '/mois',
      SHOW_GRAPH: 'Afficher le graphique',
      SHOW_DETAILS: 'Afficher les détails',
      HIDE_DETAILS: 'Masquer les détails',
      SIMULATED_SAVING_OUTCOMES: 'RÉSULTATS D’ÉPARGNE SIMULÉS',
      GRAPH_SUBTITLE:
        'des résultats finaux à la date cible sont supérieurs à la valeur « Objectif atteint » (point rouge)',
      GRAPH_SUBSUBTITLE: 'La valeur future de votre objectif est de ',
      GRAPH_SUBSUBTITLE_POPUP:
        'En supposant un taux d’inflation annuel moyen de ',
      GRAPH_LEGEND_LOW: 'Du plus bas jusqu’au 5e centile',
      GRAPH_LEGEND_MIDDLE: 'Du 5e centile à l’objectif atteint',
      GRAPH_LEGEND_HIGH: 'De l’objectif atteint au 95e centile',
      GRAPH_X_AXIS: 'Mois jusqu’à la date cible',
      LEARN_MORE: 'Afficher plus',
      SHOW_LESS: 'Afficher moins',
      RESULTS_SAVING_PREFIX: 'Épargner',
      RESULTS_MONTH_SUFFIX: '/ mois pendant',
      RESULTS_YEARS_SUFFIX: 'ans',
      FUTURE_VALUE_LABEL: "Valeur future de l'objectif",
      TOTAL_CONTRIBUTIONS_LABEL: 'Contributions totales',
      TOTAL_RETURNS_LABEL: 'Rendements totaux',
      TOTAL_RETURNS_SUB: 'des rendements simulés se situent au-dessus de',
      STARTING: 'de départ',
      ADDITIONAL: 'supplémentaire',
      INFLATION_SUFFIX: "% d'inflation",
      IN_YEARS_PREFIX: 'Dans',
      YEARS_AT: 'ans à',
      SIMULATED_OUTCOMES_TITLE: "Résultats d'épargne simulés",
      CHART_SUBTITLE_1:
        'des résultats finaux à la date cible sont supérieurs à la valeur future de votre objectif',
      EDUCATION: {
        TITLE: 'Épargner pour les études de votre enfant (REEE)',
        SUBTITLE:
          'Commencez à planifier dès maintenant. Ils grandissent si vite.',
        TABLE_TITLE: 'Coût moyen des études au Canada (2025)',
        TABLE_SUBTITLE: 'Études postsecondaires / Total sur 4 ans',
        TUITION: 'Frais de scolarité :',
        ROOM_AND_BOARD: 'Logement et repas :',
        TOTAL: 'Total :',
        CONTRIBUTION_TITLE: 'Contribution maximale à vie au REEE :',
        CONTRIBUTION_SUBTITLE: '50,000 $ par bénéficiaire admissible',
        GRANT_TITLE: 'SCEE (Subvention canadienne pour l’épargne-études) :',
        GRANT_TEXT:
          'Le montant de la subvention correspond à 20 % de vos cotisations annuelles, jusqu’à concurrence de 500 $ par année et d’un maximum à vie de 7 200 $ par bénéficiaire. Pour plus d’information, visitez le site',
        HERE: 'ici',
        QESI_TITLE: 'Incitatif québécois à l’épargne-études (IQEE):',
        QESI_TEXT:
          'Les résidents du Québec peuvent recevoir un crédit d’impôt provincial remboursable de 10 % sur les cotisations annuelles à un REEE, jusqu’à 250 $ par année et par bénéficiaire, pour un maximum à vie de 3 600 $. L’IQEE est versé directement dans votre REEE.',
      },
      RETIREMENT: {
        TITLE: 'Épargner pour la retraite (REER)',
        SUBTITLE: 'Faites croître votre patrimoine pour vos années dorées.',
        TARGET_TITLE: 'Objectif d’épargne-retraite',
        TARGET_SUBTITLE: 'De 500 000 $ à plus de 1 M$',
        TARGET_TEXT:
          'Le montant dont vous aurez besoin à la retraite dépend de votre style de vie et de vos objectifs. Essayez différents scénarios ci-dessous, trouvez ce qui vous convient et commencez vos cotisations mensuelles dès maintenant.',
        RRSP_TITLE: 'Maximum du REER 2026 :',
        RRSP_SUBTITLE:
          'La limite de cotisation correspond à 18 % de votre revenu gagné, jusqu’à un maximum annuel de 33 810 $. Cette limite peut être plus basse si vous avez un régime de pension d’employeur, ou plus haute si vous avez des droits inutilisés des années précédentes. Consultez votre avis de cotisation de l’ARC pour plus de détails.',
      },
    },
  },
};
